module.exports = __webpack_public_path__ + "media/images/lb/444-6f4d5836469c43a58fc3a6534e5a4f53.svg";